<div class="loading" *ngIf="show">
  <div>
    <em class="fa fa-spinner fa-spin fa-3x"></em>
  </div>
</div>
